var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [
        _vm._v(
          " " +
            _vm._s(
              _vm.$ct("sign-sale-type-number", {
                type: _vm.saleTypeName,
                number: _vm.sale.ComputedFriendlyID,
              })
            ) +
            " "
        ),
      ]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { md: "6", xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("name-of-signed-by"),
                      autofocus: true,
                    },
                    model: {
                      value: _vm.signedBy,
                      callback: function ($$v) {
                        _vm.signedBy = $$v
                      },
                      expression: "signedBy",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-signature-canvas", {
        key: _vm.key,
        staticClass: "canvas",
        attrs: { format: "image/png" },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      }),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c(
            "w-button",
            {
              staticClass: "cancel ml",
              attrs: { icon: "redo" },
              on: {
                click: function ($event) {
                  return _vm.reset()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("modal.reset")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.valid },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }